import { Amenity } from "../types";

const AnemitiesMobile = ({ amenities }: { amenities: Amenity[] }) => {
  return (
    <div className="grid grid-cols-1 gap-4">
      {amenities?.slice(0, 5).map((amenity, index) => (
        <div key={index} className="flex gap-2">
          <img src={amenity.Icon} alt={amenity.Text} className="w-6 h-6" />
          <span className="text-[#28282B] font-jost font-normal">{amenity.Text}</span>
        </div>
      ))}
    </div>
  );
};

export default AnemitiesMobile;
